import React from 'react';
import styled from 'styled-components';
import { Cell } from '@carvana/showroom-grid';
import { getMediaQuery } from '@carvana/showroom-theme';
import { nanoid } from 'nanoid';
import {
  HeaderTextBlock,
  HeaderTextBlockTitle
} from '../../../styles/text-block/header-text-block';
import { Section, InnerSection } from '../../../styles/section/section';
import { ArticleLink } from '../../../styles/article-link';
import { sortArrayBasedonArrayOrder } from '../../../utils/sort-array-based-on-array-order';
import { useHomeContext } from '../context';
import { useSupportContext } from '../../../helpers/context-provider';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';
import { useBreakpoint } from '../../../helpers/breakpoint-provider';

const ArticleInnerSection = styled(InnerSection)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    flex-direction: row;
  }
`;

const Column = styled(Cell).attrs({ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 })``;

const Article = styled.div`
  padding-bottom: 1.2rem;
`;

export const PopularArticles = () => {
  const { funnelStage } = useSupportContext() || {};
  const { isTablet, isDesktop } = useBreakpoint();
  const data = useHomeContext();
  const articles = data?.allStrapiArticle?.edges;
  const sortedArticleIds = data?.getSupportData?.articles?.slice(0, 9);
  const tempSortedArticles = sortArrayBasedonArrayOrder(
    articles,
    sortedArticleIds,
    (x) => x.node.uid
  );
  const sortedArticles =
    tempSortedArticles && tempSortedArticles?.length > 0
      ? tempSortedArticles?.slice(0, 9)
      : articles?.slice(0, 9);
  const headerTextBlockTitleHeading = funnelStage === 'PreAccount' ? 'Popular' : 'Recommended';
  const [ref] = SendInViewEvent({
    isLoading: data?.isLoading,
    component_name: `home_${headerTextBlockTitleHeading.toLowerCase()}_articles`,
    data: { articles, sortedArticleIds, sortedArticles }
  });

  const getLimitBasedOnScreenWidth = () => {
    const limit = 9;

    if (isDesktop) return Math.ceil(limit / 3);
    if (isTablet) return Math.ceil(limit / 2);

    return limit;
  };

  const createColumns = (array) => {
    const columns = [];
    const limit = getLimitBasedOnScreenWidth();
    helper(array, columns, limit);

    return columns;
  };

  const helper = (array, columns, limit) => {
    if (!array.length) return null;

    const articles = array.slice(0, limit).map((article) => (
      <Article key={article.node.id} gutter={20}>
        <ArticleLink article={article.node} />
      </Article>
    ));

    const column = (
      <Column gutter={20} key={nanoid()}>
        {articles}
      </Column>
    );

    columns.push(column);
    const slicedArray = array.splice(limit);

    helper(slicedArray, columns, limit);
  };

  return (
    <Section ref={ref}>
      <HeaderTextBlock size="responsive">
        <HeaderTextBlockTitle>{headerTextBlockTitleHeading} Articles</HeaderTextBlockTitle>
      </HeaderTextBlock>

      <ArticleInnerSection>{createColumns(sortedArticles)}</ArticleInnerSection>
    </Section>
  );
};
